var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrap5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1802_12167)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0188,
    y: 26.1127,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5188,
    y: 26.6127,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#D9D9D9",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8806 39.936C45.2957 39.936 44.1229 41.3233 44.1754 42.8277C44.2258 44.2731 44.1603 46.145 43.689 47.6716C43.2161 49.2025 42.4169 50.1726 41.1111 50.2971V51.7029C42.4169 51.8277 43.2161 52.7973 43.689 54.3284C44.1603 55.855 44.2257 57.727 44.1753 59.1723C44.1228 60.6766 45.2956 62.064 46.8808 62.064H63.1214C64.7064 62.064 65.879 60.6768 65.8265 59.1723C65.7761 57.727 65.8416 55.855 66.3128 54.3284C66.7857 52.7973 67.583 51.8273 68.8889 51.7029V50.2971C67.5831 50.1723 66.7858 49.2027 66.3128 47.6716C65.8415 46.1453 65.7761 44.2731 65.8265 42.8277C65.879 41.3235 64.7064 39.936 63.1214 39.936H46.8804H46.8806ZM59.9435 53.5573C59.9435 55.6288 58.3983 56.8852 55.834 56.8852H51.4689C51.344 56.8852 51.2243 56.8356 51.136 56.7473C51.0477 56.659 50.9981 56.5392 50.9981 56.4144V45.5857C50.9981 45.4609 51.0477 45.3411 51.136 45.2528C51.2243 45.1645 51.344 45.1149 51.4689 45.1149H55.8092C57.9473 45.1149 59.3506 46.2731 59.3506 48.0513C59.3506 49.2994 58.4066 50.4168 57.204 50.6125V50.6777C58.8411 50.8572 59.9435 51.9911 59.9435 53.5573ZM55.358 46.6074H52.8691V50.123H54.9654C56.586 50.123 57.4795 49.4705 57.4795 48.3041C57.4794 47.211 56.7111 46.6074 55.358 46.6074ZM52.8691 51.5179V55.3922H55.4496C57.1369 55.3922 58.0306 54.7152 58.0306 53.4428C58.0306 52.1705 57.1118 51.5177 55.3411 51.5177H52.8691V51.5179Z",
    fill: "#7952B3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1802_12167",
    x: -19.9812,
    y: -23.8873,
    width: 150,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1802_12167"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1802_12167",
    result: "effect2_dropShadow_1802_12167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1802_12167",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap5);
export default __webpack_public_path__ + "static/media/bootstrap5.8072220fea28d873c96381545f150d89.svg";
export { ForwardRef as ReactComponent };